import { render } from "./PlayerMini.vue?vue&type=template&id=1674f522&scoped=true"
import script from "./PlayerMini.vue?vue&type=script&lang=js"
export * from "./PlayerMini.vue?vue&type=script&lang=js"

import "./PlayerMini.vue?vue&type=style&index=0&id=1674f522&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/gurupadukaweb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1674f522"]])

export default __exports__